export default __webpack_public_path__ + "static/hat-29624b91f3a57a6730c03ce4aa11299e.png";